import React from 'react';
import moment from 'moment';
import { Card } from 'react-bootstrap';
import { Button, Col, Row } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const ComplementoVehiculosUsadosResumen = ({ data = {}, onEdit, onDelete }) => {

  const handleOnDelete = () => {
    onDelete('VehiculoUsado');
  }

  const handleOnEdit = () => {
    onEdit('VehiculoUsado', data);
  }

  const renderLeyends = (data, item, index = '') => {
    return (
      <SingleLeyendLabel
        key={ index.toString() + item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          Vehículos Usados
        </Card.Subtitle>

        <Row className="py-3">
          <Col sm md="6">
            { labels.filter((item) => item.col === 1).map(renderLeyends.bind(null, data)) }
          </Col>
          <Col sm md="6">
            { labels.filter((item) => item.col === 2).map(renderLeyends.bind(null, data)) }
          </Col>
        </Row>

        <strong className="text-muted">Información aduanera</strong>

        <Row className="py-3">
          <Col>
            { (data.InformacionAduanera || []).map((data, index) => {
                return informacionAduaneraLabels.map(item => renderLeyends(data, item, index.toString()));
              }
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <Button variant="danger"
              className="mr-3"
              onClick={ handleOnDelete }
            >
              Quitar
            </Button>

            <Button variant="secondary"
              onClick={ handleOnEdit }
            >
              Editar
            </Button>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoVehiculosUsadosResumen;

const labels = [
  {
    label: 'Monto de adquisión',
    index: 'montoAdquisicion',
    col: 1
  },
  {
    label: 'Monto de enajenación',
    index: 'montoEnajenacion',
    col: 1
  },
  {
    label: 'Clave vehicular',
    index: 'claveVehicular',
    col: 1
  },
  {
    label: 'Marca',
    index: 'marca',
    col: 1
  },
  {
    label: 'Tipo',
    index: 'tipo',
    col: 1
  },
  {
    label: 'Modelo',
    index: 'modelo',
    col: 2
  },
  {
    label: 'Número de motor',
    index: 'numeroMotor',
    col: 2
  },
  {
    label: 'Número de serie',
    index: 'numeroSerie',
    col: 2
  },
  {
    label: 'NIV',
    index: 'NIV',
    col: 2
  },
  {
    label: 'Valor',
    index: 'valor',
    col: 2
  },
];

const informacionAduaneraLabels = [
  {
    label: 'Número',
    index: 'numero',
    col: 1
  },
  {
    label: 'Fecha',
    index: 'fecha',
    col: 1,
    render: (value) => {
      return (
        <span>
          { moment(value).format('DD/MM/YYYY') }
        </span>
      )
    }
  },
  {
    label: 'Aduana',
    index: 'aduana',
    col: 1
  }
];